import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  RequestCreateFactoryTaxInvoice,
  RequestUpdateFactoryTaxInvoice,
  ResponseFactoryTaxInvoice,
} from "services/interface";
import {
  createFactoryTaxInvoice,
  updateFactoryTaxInvoice,
} from "services/factory";

export const useCreateFactoryTaxInvoice = (): UseMutationResult<
  ResponseFactoryTaxInvoice,
  Error,
  RequestCreateFactoryTaxInvoice,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation<
    ResponseFactoryTaxInvoice,
    Error,
    RequestCreateFactoryTaxInvoice,
    unknown
  >({
    mutationFn: (input: RequestCreateFactoryTaxInvoice) =>
      createFactoryTaxInvoice(input),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["factory_data_by_id", variables.factory_id],
      });
    },
  });
};

export const useUpdateFactoryTaxInvoice = (): UseMutationResult<
  ResponseFactoryTaxInvoice,
  Error,
  RequestUpdateFactoryTaxInvoice,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation<
    ResponseFactoryTaxInvoice,
    Error,
    RequestUpdateFactoryTaxInvoice,
    unknown
  >({
    mutationFn: (input: RequestUpdateFactoryTaxInvoice) =>
      updateFactoryTaxInvoice(input),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["factory_data_by_id", variables.factory_id],
      });
    },
  });
};
